import React from "react";
import { ReactComponent as CardHeaderDecore } from "../../../assets/sahaba-assets/headerFeature.svg";

const cardData = [
    {
        title: "مرونة في التعلم",
        description: "تقدر تذاكر في أي وقت وأي مكان",
    },
    {
        title: "جوائز وتحديات",
        description: "مسابقات وتحديات وجوائز تشجيعية ليك ولأصحابك.",
    },
    {
        title: "تحديات مستمرة",
        description: "هنضيف مواد ودروس جديدة باستمرار علشان تفضل متابع كل الجديد.",
    },
    {
        title: "كورسات مجانية",
        description: "هنقدملك كورسات مجانية علشان تجرب براحتك.",
    },
];

const Card = () => {
    return (
        <div className="w-full h-full flex flex-wrap justify-evenly gap-6 md:gap-3 relative z-10">
            {cardData.map((card, index) => (
                <div
                    key={index}
                    className="w-[300px] font-lama h-[250px] bg-moonBlue-50 dark:bg-moonBlue-900/50 smooth rounded-xl shadow-md border border-gray-300 relative overflow-hidden"
                >
                    <div className="w-full h-2 bg-moonBlue-700 dark:bg-moonBlue-300 smooth absolute top-0"></div>
                    <div className="relative text-center p-5">
                        <CardHeaderDecore className="absolute w-[80px] top-3 -rotate-1 opacity-50" />
                        <h1 className="text-3xl font-bold text-moonBlue-900 dark:text-moonBlue-200 smooth mt-10">
                            {card.title}
                        </h1>
                    </div>
                    <p className="mt-4 text-lg text-center text-gray-600 dark:text-gray-200 smooth px-4">
                        {card.description}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default Card;
